import styled from 'styled-components';

export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  width: 100%;

  @media (max-width: 720px) {
    flex-direction: column;
  }
`;
